import React from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/images/DAICB logo.png';

const Header = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  
  return (
    <HeaderContainer>
      <Nav>
        <LogoContainer>
          <Link to="/">
            <img src={logo} alt="Dreams AI Can Buy Logo" />
          </Link>
        </LogoContainer>
        <NavLinks>
          {isHomePage ? (
            <>
              <a href="#about">About</a>
              <a href="#testimonials">Testimonials</a>
              <a href="#faq">FAQ</a>
              <a href="#booking">
                <CTAButton>Book Your Session</CTAButton>
              </a>
            </>
          ) : (
            <>
              <Link to="/#about">About</Link>
              <Link to="/#testimonials">Testimonials</Link>
              <Link to="/#faq">FAQ</Link>
              <Link to="/#booking">
                <CTAButton>Book Your Session</CTAButton>
              </Link>
            </>
          )}
        </NavLinks>
      </Nav>
    </HeaderContainer>
  );
};

const HeaderContainer = styled.header`
  background-color: var(--white);
  padding: 1rem 0;
  box-shadow: var(--shadow);
  position: sticky;
  top: 0;
  z-index: 100;
`;

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const LogoContainer = styled.div`
  img {
    height: 50px;
    width: auto;
  }
`;

const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;

  a {
    color: var(--dark-blue);
    font-weight: 500;
    transition: var(--transition);
  }

  a:hover {
    color: var(--primary-color);
  }

  @media (max-width: 768px) {
    gap: 1rem;
  }
`;

const CTAButton = styled.button`
  background-color: var(--primary-color);
  color: var(--white);
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);

  &:hover {
    background-color: #003b8a;
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export default Header;
